<script setup lang="ts">
import { cn } from '@/lib/utils';
import { useVModel } from '@vueuse/core';
import type { HTMLAttributes } from 'vue';

const props = defineProps<{
  defaultValue?: string | number;
  modelValue?: string | number;
  class?: HTMLAttributes['class'];
}>();

const emits = defineEmits<{
  (e: 'update:modelValue', payload: string | number): void;
}>();

// Removed passive so that the value can be modified programmatically.
// See https://vueuse.org/core/useVModel/#type-declarations
const modelValue = useVModel(props, 'modelValue', emits, {
  defaultValue: props.defaultValue,
});
</script>

<template>
  <input
    v-model="modelValue"
    v-bind="$attrs"
    :class="
      cn(
        `flex h-10 w-full rounded-lg border border-input 
        bg-background px-3 py-2 text-sm ring-offset-background 
        file:border-0 file:bg-transparent file:text-sm file:font-medium 
        placeholder:text-muted-foreground 
        focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-600 focus-visible:ring-offset-2 
        disabled:cursor-not-allowed disabled:opacity-50`,
        props.class,
      )
    "
  />
</template>
